<template>
  <a class="icon relative block flex-shrink-0 bg-gray-300 rounded overflow-hidden" :href="`https://twitch.tv/${channel.name}`" target="_blank" :style="{ width: `${iconSize}px`, height: `${iconSize}px` }">
    <template v-if="config.iconType === 'Avatar' && channel.avatar">
      <div class="av" :class="channel.avatar" v-if="iconSize === 50" />
      <img :width="iconSize" :height="iconSize" :src="`${config.server}/avatars/${iconSize}/${channel.avatar}.jpg`" alt="" loading="lazy" v-else />
    </template>
    <template v-if="config.iconType === 'Avatar' && !channel.avatar">
      <small class="av flex items-center justify-center text-center  text-gray-400 leading-4 font-extrabold" v-if="iconSize === 50">NO<br />AVATAR<br />YET</small>
      <small class="flex items-center justify-center text-center  text-gray-400 leading-4 font-extrabold" :style="{ width: `${iconSize}px`, height: `${iconSize}px` }" v-else>NO<br />AVATAR<br />YET</small>
    </template>
    <template v-if="config.iconType === 'Logo'">
      <img :width="iconSize" :height="iconSize" :src="channel.logo" alt="" loading="lazy" />
    </template>
  </a>
</template>

<script>
  import { computed } from 'vue'
  import { config, channelsById, streamsById } from '@/store'

  export default {
    name: 'ChannelIcon',
    props: {
      channelId: {
        type: Number,
        required: true,
      },
      size: {
        type: Number,
        required: false,
      },
    },
    setup(props) {
      const stream = computed(() => streamsById.value[props.channelId])
      const channel = computed(() => channelsById.value[props.channelId] || stream.value.channel)
      const iconSize = computed(() => props.size || config.iconSize)
      return { config, channel, iconSize }
    },
  }
</script>

<style scoped>
  .icon:hover > * {
    filter: brightness(1.1);
  }
</style>
